












import Component from 'vue-class-component';
import { VModel } from 'vue-property-decorator';
import { CustomerFormModel } from '@/context/customer/model/CustomerFormModel';
import Vue from 'vue';
import TextField from '@/general/component/TextField.vue';

@Component({
  components: { TextField }
})
export default class CustomerFormTemplate extends Vue {
  @VModel() model!: CustomerFormModel;
  valid: boolean = true;

  get rules(): Record<string, unknown> {
    return {};
  }

  /**
   *   private String name;
   private String street;
   private String city;
   private String country;
   private Boolean active;
   */
}
